export class MemberLabAttestation {

    public memberCIN:string;
    public measurementPeriod:string;
    public cbC_DateOfLabs:Date;
    public cbC_DateOfReview:Date;
    public cbC_WBC:string;
    public cbC_Hgb:string;
    public bmP_DateOfLabs:Date;
    public bmP_DateOfReview:Date;
    public bmP_Na:string;
    public bmP_K_Hgb:string;
    public bmP_Scr:string;
    public bmP_BUN:string;
    public tsH_DateOfLabs:Date;
    public tsH_DateOfReview:Date;
    public lfT_DateOfLabs:Date;
    public lfT_DateOfReview:Date;
    public lfT_AST:string;
    public lfT_ALT:string;
    public lfT_AlKphos:string;
    public hgB_DateOfLabs:Date;
    public hgB_DateOfReview:Date;    
    public fastingLipidPanel_DateOfLabs:Date;
    public fastingLipidPanel_DateOfReview:Date;
    public fastingLipidPanel_TotalCholesterol:string;
    public fastingLipidPanel_LDL:string;
    public fastingLipidPanel_HDL:string;
    public fastingLipidPanel_Triglyceride:string;
    public scoreValue:number;
    public summary: string;
    public createdDate:Date;
    public createdBy:string;
    public attestationDate:Date;
    public attestationBy:string;
    public userName:string;
}


export class AttestationPeriod {

    public startDate:Date;
    public endDate:Date;
    public dueDate:Date;
    public year:Date;
    public semester:string;
    public semesterCode:string;
    public measurementPeriod:string;
    public description:string;
    public availableToAttest:boolean;
}